import { MarketStatus } from '@ps/isp-web-services-types';
import produce from 'immer';

import type { GroupedMarketTemplateData } from '@swf/sports/components/GroupedMarketTemplate/types';
import type { MarketPollingData } from '@swf/sports/types/market';
import { notEmpty } from '@swf/sports/utils/notEmpty';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  golfMatchesRequested: (
    state: State,
    { isBackgroundLoading = false }: { isBackgroundLoading?: boolean } = {}
  ): State => ({
    ...state,
    isLoading: !isBackgroundLoading,
    error: undefined
  }),
  golfMatchesLoadFailure: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    error: payload
  }),
  golfMatchesLoadSuccess: (state: State, payload: GroupedMarketTemplateData): State => ({
    ...state,
    ...payload,
    isLoading: false,
    hasPreloaded: true,
    error: undefined
  }),
  golfMatchesMarketsUpdated: (state: State, { data, closed }: MarketPollingData): State =>
    produce(state, (draft) => {
      Object.entries(data).forEach(([marketUpdateId, marketUpdate]) => {
        Object.values(draft.markets)
          .filter(notEmpty)
          .forEach((market) => {
            if (closed.includes(market.marketId)) {
              market.marketStatus = MarketStatus.CLOSED;
              return;
            }

            if (market.marketId === marketUpdateId && marketUpdate) {
              updateMarket(market, marketUpdate);
            }
          });
      });

      return draft;
    })
};
